import Icon from '@ui/components/Icon/Icon';
import Tooltip from '../../UI/Tooltip/Tooltip';
import { DARK_GREY, WHITE } from '../../../styles/colors';

import './LabelGroupsTooltip.scss';

const LabelGroupsTooltip = ( ) => {
	const tooltipData = (
		<div className="tippy-tooltip-content" style={{ textAlign: 'left', fontSize: '10px', width: '200px' }}>
			<p className="tooltip-text" style={{ color: WHITE }}>
				Create groups of labels to quickly manage projects with similar workflows.
				<span style={{ fontWeight: 'bold', color: WHITE }}>
					&nbsp;Editing or deleting&nbsp;
				</span>
				them won&apos;t affect current projects.
			</p>
		</div>
	);

	return (
		<div className="LabelGroupsTooltip">
			<Tooltip
				className="label-groups-tooltip"
				html={tooltipData}
				position="right"
			>
				<div data-testId="tooltipIcon">
					<Icon
						icon="info_outlined"
						size={16}
						color={DARK_GREY}
					/>
				</div>
			</Tooltip>
		</div>
	);
};

export default LabelGroupsTooltip;
